document.addEventListener("DOMContentLoaded", async () => {
  const btn = document.getElementById("esprit-jour-btn");
  const popup = document.getElementById("esprit-jour-popup");
  const closeBtn = document.getElementById("close-esprit-jour");
  const cardInner = document.getElementById("esprit-jour-card-inner");
  const cardImage = document.getElementById("esprit-jour-image");

  if (!btn || !popup) return;

  const totalCartes = 33;
  const heureReset = 8; // 8h du matin
  const assetBase = window.heAssetBase || "";
  const cartesUrl = window.heCartesUrl || "";

  function getDateForTirage(now) {
    // Décale la date réelle de 8h en arrière avant de la tronquer à minuit
    const tirageDate = new Date(now.getTime() - heureReset * 60 * 60 * 1000);
    //tirageDate.setHours(0, 0, 0, 0);
     console.log("→ Date du jour :", tirageDate);
    return tirageDate;
  }

  function carteAuto(date) {
    const jour = date.getDate();
    const mois = date.getMonth() + 1;
    const annee = date.getFullYear();
    return ((jour * 37 + mois * 13 + annee) % totalCartes) + 1;
  }

  async function getCartePredefinie(dateISO) {
    try {
      const res = await fetch(cartesUrl, { cache: "no-store" });
      if (!res.ok) return null;
      const data = await res.json();
      const match = data.cards.find(c => c.date === dateISO);
      return match ? match.id : null;
    } catch (e) {
      console.warn("Impossible de charger Cartes-du-jour.json :", e);
      return null;
    }
  }

  function dateISOlocale(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  async function getCarteDuJour() {
    const now = new Date();
    const tirageDate = getDateForTirage(now);
    const dateISO = dateISOlocale(tirageDate);
     console.log("→ Date du jour ISO :", dateISO);
    const predef = await getCartePredefinie(dateISO);
    if (predef) return predef;
    return carteAuto(tirageDate);
  }

  const carteId = await getCarteDuJour();
  const imageUrl = assetBase + "Carte-" + String(carteId).padStart(2, "0") + ".png";
  console.log("→ Carte du jour :", carteId, imageUrl);
  cardImage.src = imageUrl;

  // --- Ouverture du popup ---
  btn.addEventListener("click", () => {
    popup.classList.add("open");
    cardInner.classList.remove("flipped");
    setTimeout(() => cardInner.classList.add("flipped"), 900);
  });

  // --- Fermeture ---
  closeBtn.addEventListener("click", () => popup.classList.remove("open"));
  popup.querySelector(".esprit-jour-overlay")
       .addEventListener("click", () => popup.classList.remove("open"));
});
// JavaScript Document
